<template>
  <div>
    <div class="icon-demo">
      <p>图标配置文件位置：src/static/js/icon.js</p>
      <div>图标<svg-icon style="font-size: 20px" icon="play" /> 的代码为： &lt;svg-icon icon="play" /&gt;</div>
      <div>改变图标<svg-icon class="example-icon" icon="play" /> 颜色大小的代码为： &lt;svg-icon class="example-icon" icon="play" /&gt;</div>
      <div>
        :deep(.example-icon svg) {
        fill: #3262FD;
        font-size: 40px;
        }
      </div>
    </div>
    <ul class="icon-demo-list">
      <li v-for="item in iconList" :key="item">
        <svg-icon class="demo-icon" :icon="item" />
        <p>{{ item }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import icon from '@/static/js/icon.js'
export default {
  data() {
    return {
      iconList: []
    }
  },
  mounted() {
    Object.keys(icon).forEach(key => {
      this.iconList.push(key)
    })
  }
}
</script>
<style lang="less" scoped>
.icon-demo {
  margin-bottom: 24px;
}
:deep(.example-icon svg) {
  fill: #3262FD;
  font-size: 40px;
}
.icon-demo-list {
  margin-right: -16px;
  li {
    display: inline-block;
    font-size: 40px;
    margin-right: 16px;
    margin-bottom: 16px;
    p {
      font-size: 14px;
    }
    &:hover {
      color: #3262FD;
      :deep(.demo-icon svg) {
        fill: #3262FD;
      }
    }
  }
}
</style>